import $ from 'jquery';
import './turn.min.js';
import '../scss/index.scss';
import throttle from 'lodash/throttle';
import { Howl } from 'howler';
import type { Howl as HowlType } from 'howler';
import { fetchContent } from '../apis/api';
import { browerVersion } from './utils';
import YouMeng from './YouMeng';
import {
  loadPageData,
  defaultPageHeight,
  defaultPageWidth,
  PageData,
} from './pageData';
import { initWxShare } from './wxSdk';
import createPoster from './poster';
import { showToast } from './toast';
import tastTag from '../assets/images/test-tag.png';

import loadingSvg from '../assets/svg/loading-1.svg';

type LoadingStyleType = 'bar' | 'circle';
const loadingStyle: string = 'bar' as LoadingStyleType;
const showLoadingText = true;
const flipsound = require('../assets/music/flipsound.mp3');

const longEpapers: string[] = [];
const longEpaperAnimationDuration = 12;

const version = browerVersion();
const issueName = process.env.PROJECT_TITLE || '';
let isFlodMobile = false;

let flipbgm: HowlType;
/**
 * 初始化翻页音效
 */
const initBgm = () => {
  flipbgm = new Howl({
    src: flipsound,
    volume: 0.5,
    preload: true,
    autoplay: false,
  });
};

/**
 * 初始化容器大小
 */
const initContainerSize = () => {
  // 获取容器高度
  const { clientHeight, clientWidth } = document.body;
  const ratio = clientWidth / clientHeight;
  if (version.mobile && ratio > 0.75) {
    isFlodMobile = true;
  }
  // 根据是否为移动端，设置容器大小
  if (!version.mobile || isFlodMobile) {
    // 若非移动端，则将h5宽高比设置为9:16
    const containerWidth = Math.floor(clientHeight * 0.5625);
    $('.container').css({ width: `${containerWidth}px` });
    $('.flip-body').css({
      width: `${containerWidth * 0.8}px`,
      height: `${containerWidth * 1.18 + 32}px`,
    });
  }
};
/**
 * 计算图片与map的area中coords的实际坐标
 * @param el
 */
const initMapResize = (el: HTMLMapElement | JQuery<HTMLMapElement>) => {
  const maps = $(el);
  // 避免传参了多个map，因此使用each函数
  maps.each((index1, map) => {
    // 获取map对应的图片实际尺寸和目前在页面上的尺寸
    const { naturalWidth, naturalHeight, clientWidth, clientHeight } = $(
      `.flip-image[usemap="#${map.name}"]`
    )[0] as HTMLImageElement;
    // 计算在图片实际宽高和在页面上的比例
    const xRatio = clientWidth / naturalWidth;
    const yRatio = clientHeight / naturalHeight;
    // 获取map下的所有area
    const areas = $(map).find('area');
    // 遍历area并修改coords
    areas.each((index2, area) => {
      // 由于coords是多个坐标点的集合并以逗号分隔，因此需要拆分
      const coords = $(area).attr('coords')?.split(',') || [];
      const newCoords: number[] = [];
      coords.forEach((coord, index3) => {
        if (index3 % 2 === 0) {
          newCoords.push(Math.ceil(Number(coord) * xRatio));
        } else if (index3 % 2 === 1) {
          newCoords.push(Math.ceil(Number(coord) * yRatio));
        }
      });
      // 将页面上新的坐标赋值给area
      $(area).attr('coords', newCoords.join(','));
    });
  });
};

let allPromise = 0;
let currentEpaperImage = '';
let pageDataList: PageData[] = [];
/**
 * 初始化电子报的翻页效果
 */
const initFlipbookTurn = () => {
  // 获取电子报的容器宽高
  const flipbookWidth = Math.ceil($('.flip-body').width() || 0);
  const flipbookHeight = Math.ceil(
    (flipbookWidth / defaultPageWidth) * defaultPageHeight
  );
  // 设置翻页效果
  $('#flipbook').turn({
    width: flipbookWidth,
    height: flipbookHeight,
    display: 'single',
    when: {
      turning: () => {
        // 当翻页时播放翻页音效
        flipbgm.play();
      },
      turned: (evt: Event, page: number) => {
        // 当翻页完成时计算新的map、area、coords
        initMapResize($(`map[name=PagetoMap-${page - 1}]`));
        // 获取当前翻页的电子报图片、电子报上的文章
        const { articles, image } = pageDataList[page - 1];
        currentEpaperImage = image as string;
        if (articles && articles.length) {
          // 如果有文章内容，则将文章标题填到稿件导航处的弹窗内容
          const articleHtmls = articles.map(
            (article) =>
              `<div class="article-box" data-date="${article.date}" data-article="${article.json}">${article.title}</div>`
          );
          $('.article-popup-body').html(articleHtmls.join(''));
        } else {
          // 如果没有文章内容，则清空稿件导航处的弹窗内容
          $('.article-popup-body').empty();
        }
        // 让翻页效果卷起一个角
        $('#flipbook').turn('peel', 'br');
      },
      last: () => {
        showToast({
          content: '已经是最后一页了',
          showMask: false,
          duration: 1000,
        });
      },
      first: () => {
        showToast({
          content: '已经是第一页了',
          showMask: false,
          duration: 1000,
        });
      },
    },
  });
  YouMeng.pushRecord({ issueName }, 'gzcmc.xhc.h5.issue.layout.flip', 'TOUCH');
};

/**
 * 根据不同的情况，延时显示电子报翻页容器
 * @param timeout
 */
const showFlipbook = (timeout: number) => {
  setTimeout(() => {
    $('.loading-content').hide();
    $('.long-epaper-content').hide();
    $('.flip-content').show();
    initFlipbookTurn();
  }, timeout);
};

/**
 * 初始化电子报内部的html代码
 */
const initFlipbookHtml = () => {
  const flipbookHtmls = pageDataList.map((item, index) => {
    const areaHtmls =
      item.articles?.map(
        (area) =>
          `<area class="flip-area" data-date="${area.date}" data-article="${
            area.json
          }" shape="polygon" coords="${area.coords.join(',')}"/>`
      ) || [];
    const mapHtml = `<map class="flip-map" name="PagetoMap-${index}">${areaHtmls.join(
      ''
    )}</map>`;
    const imageHtml = `<img usemap="#PagetoMap-${index}" class="flip-image" src="${item.image}">`;
    return `<div class="flip-page">${imageHtml}${mapHtml}</div>`;
  });
  $('#flipbook').append(flipbookHtmls.join(''));
  const flipbookWidth = Math.ceil($('.flip-body').width() || 0);
  const flipbookHeight = Math.ceil(
    (flipbookWidth / defaultPageWidth) * defaultPageHeight
  );
  $('#flipbook').css({
    width: `${flipbookWidth}px`,
    height: `${flipbookHeight}px`,
  });
  const pageHtmls = pageDataList.map(
    (page, index) =>
      `<div class="page-box" data-index="${index}">${page.title}</div>`
  );
  $('.page-popup-body').html(pageHtmls.join(''));
  if (!longEpapers.length && loadingStyle === 'bar') {
    showFlipbook(500);
  } else if (!longEpapers.length && loadingStyle === 'circle') {
    showFlipbook(0);
  } else {
    showFlipbook(longEpaperAnimationDuration * 1000 * 0.8);
  }
};

let requestAnimationFrameId = 0;
let currentProgress = 0;
let showProgress = 0;
const addProgressNumber = () => {
  if (showProgress < currentProgress) {
    showProgress += 1;
    $('.loading-circle-text').text(`${showProgress}%`);
  }
  requestAnimationFrameId = window.requestAnimationFrame(addProgressNumber);
  if (showProgress === currentProgress && currentProgress === 100) {
    window.cancelAnimationFrame(requestAnimationFrameId);
    initFlipbookHtml();
  }
};

/**
 * 加载电子报数据
 */
const initPageData = async () => {
  let successNum = 0;
  if (loadingStyle === 'circle') {
    addProgressNumber();
  }
  pageDataList = await loadPageData(
    (num) => {
      allPromise = num;
    },
    () => {
      successNum += 1;
      currentProgress = Math.ceil((successNum / allPromise) * 100);
      if (longEpapers.length) return;
      if (loadingStyle === 'bar') {
        $('.loading-bar-mask').css({ width: `${100 - currentProgress}%` });
      }
    }
  );
  if (loadingStyle === 'bar') {
    initFlipbookHtml();
  }
};

const wheelHandler = (evt: Event) => {
  if ((evt.target as HTMLElement).tagName === 'BODY') {
    evt.preventDefault();
  }
};

/**
 * 获取稿件详情
 * @param date
 * @param article
 * @returns
 */
const getArticleDetail = (date: string, article: string) => {
  if (!date || !article) {
    return;
  }
  fetchContent(date, article).then((res) => {
    const {
      作者: author,
      内容: content,
      副题: subTitle,
      引题: otherTitle,
      标题: title,
      附图: images,
    } = res;
    YouMeng.pushRecord(
      { issueName, articleTitle: title },
      'gzcmc.xhc.h5.issue.manuscript.view',
      'CLICK'
    );
    if (otherTitle) {
      $('.detail-other-title-text').html(otherTitle);
      $('.detail-other-title').css({ display: 'flex' });
    } else {
      $('.detail-other-title').css({ display: 'none' });
    }
    if (title) {
      $('.detail-title').html(title);
      $('.detail-title').show();
    } else {
      $('.detail-title').hide();
    }
    if (subTitle) {
      $('.detail-sub-title-text').html(subTitle);
      $('.detail-sub-title').css({ display: 'flex' });
    } else {
      $('.detail-sub-title').css({ display: 'none' });
    }
    if (author) {
      $('.detail-author').html(author);
      $('.detail-author').show();
    } else {
      $('.detail-author').hide();
    }
    // 如果稿件内容中有附图，则将附图放在文章前面
    if (images && images.length) {
      let imageHasText = false;
      const imageHtmls = images.map((image) => {
        const imageHtml = `<img src="${
          process.env.EPAPER_BASE_URL
        }/pc/wxapp/${image['文件名'].replace(/\.\.\//g, '')}" alt="${
          image['图片说明']
        }" class="detail-image">`;
        const imageText = image['图片说明']
          ? `<div class="detail-image-text">${image['图片说明']}</div>`
          : '';
        imageHasText = imageHasText || !!image['图片说明'];
        return `<div class="detail-image-box">${imageHtml}${imageText}</div>`;
      });
      // 如果附图有文字说明，则显示在图片下方
      if (imageHasText) {
        $('.detail-image-list').addClass('detail-image-has-text');
      } else {
        $('.detail-image-list').removeClass('detail-image-has-text');
      }
      $('.detail-image-list').html(imageHtmls.join(''));
      $('.detail-image-list').show();
    } else {
      $('.detail-image-list').hide();
    }
    if (content) {
      $('.detail-text').html(content);
      $('.detail-text').show();
    } else {
      $('.detail-text').hide();
    }
  });
};

/**
 * 显示电子报的文章内容
 * @param date
 * @param article
 */
const showArticle = (date: string, article: string) => {
  getArticleDetail(date, article);
  // 使用同页弹窗的方式实现，因此需要通过pushState的方式，实现对返回按钮的复写
  window.history.pushState({}, '', window.location.href);
  document.body.addEventListener('wheel', wheelHandler, {
    passive: false,
  });
  $('.article-popup-mask').trigger('click');
  $('.detail-content').show();
  // 当监听到返回操作时，关闭稿件内容弹窗
  window.addEventListener(
    'popstate',
    () => {
      $('.detail-content').hide();
      $('.detail-other-title-text').empty();
      $('.detail-title').empty();
      $('.detail-sub-title-text').empty();
      $('.detail-author').empty();
      $('.detail-image-list').empty();
      $('.detail-text').empty();
      document.body.removeEventListener('wheel', wheelHandler);
    },
    {
      capture: false,
      once: true,
    }
  );
};

/**
 * 初始化页面上的事件监听
 */
const initEvent = () => {
  // 稿件导航弹窗遮盖层的点击事件
  $('.article-popup-mask').on('click', () => {
    $('.article-popup-body').css({ 'animation-name': 'slide-down' });
    setTimeout(() => {
      $('.article-popup-content').hide();
    }, 350);
  });
  // 稿件导航按钮的点击事件
  $('.article-navigate').on('click', () => {
    YouMeng.pushRecord(
      { issueName },
      'gzcmc.xhc.h5.issue.manuscript.navigate',
      'CLICK'
    );
    $('.article-popup-body').css({ 'animation-name': 'slide-up' });
    $('.article-popup-content').show();
  });
  // 稿件导航弹窗中稿件列表的点击事件
  $('.article-popup-content').on('click', '.article-box', (evt) => {
    YouMeng.pushRecord(
      { issueName },
      'gzcmc.xhc.h5.issue.manuscript.navigate.list',
      'CLICK'
    );
    const { date, article } = evt.currentTarget.dataset;
    showArticle(date, article);
  });
  // 版面导航弹窗遮盖层的点击事件
  $('.page-popup-mask').on('click', () => {
    $('.page-popup-body').css({ 'animation-name': 'slide-right' });
    setTimeout(() => {
      $('.page-popup-content').hide();
    }, 350);
  });
  // 版面导航按钮的点击事件
  $('.page-navigate').on('click', () => {
    YouMeng.pushRecord(
      { issueName },
      'gzcmc.xhc.h5.issue.layout.navigate',
      'CLICK'
    );
    $('.page-popup-body').css({ 'animation-name': 'slide-left' });
    $('.page-popup-content').show();
  });
  // 版面导航弹窗中版面列表的点击事件
  $('.page-popup-content').on('click', '.page-box', (evt) => {
    YouMeng.pushRecord(
      { issueName },
      'gzcmc.xhc.h5.issue.layout.navigate.list',
      'CLICK'
    );
    const { index } = evt.currentTarget.dataset;
    $('#flipbook').turn('page', Number(index) + 1);
    $('.page-popup-mask').trigger('click');
  });
  // 电子报中area的点击事件
  $('.flip-content').on('click', '.flip-area', (evt) => {
    const { date, article } = evt.currentTarget.dataset;
    showArticle(date, article);
  });
  // 稿件内容弹窗中返回按钮的点击事件
  $('.detail-back').on('click', () => {
    YouMeng.pushRecord(
      { issueName },
      'gzcmc.xhc.h5.issue.manuscript.back',
      'CLICK'
    );
    window.history.back();
  });
  // 创建海报的点击事件
  $('.flip-bottom-poster-icon').on('click', () => {
    YouMeng.pushRecord({ issueName }, 'gzcmc.xhc.h5.issue.post', 'CLICK');
    createPoster(currentEpaperImage);
  });
  $('.long-epaper-content').on('click', '.long-epaper-enter', () => {
    showFlipbook(150);
  });
};

let bodyHeight = 0;

/**
 * 加载图片资源的Promise
 * @param src 图片的来源地址
 * @returns 返回一个Promise，解析为HTMLImageElement类型的图片对象
 */
const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve) => {
    const image = new Image();
    image.src = src;
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = () => {
      resolve(image);
    };
    if (image.complete) {
      resolve(image);
    }
  });
};

/**
 * 当有长图时，初始化长图的滚动效果
 */
const initLongEpaper = async () => {
  const images = await Promise.all(
    longEpapers.map((longEpaper) => loadImage(longEpaper))
  );
  let longEpaperWidth = 0;
  images.forEach((image) => {
    const { naturalHeight, naturalWidth } = image;
    longEpaperWidth += (naturalWidth / naturalHeight) * bodyHeight;
  });
  document.body.style.setProperty(
    '--longe-paper-width',
    `-${Math.round(longEpaperWidth)}px`
  );
  const longEpaperHtml = longEpapers
    .map((longEpaper) => {
      return `<img src="${longEpaper}" class="long-epaper-image">`;
    })
    .join('');
  $('.loading-content').hide();
  $('.long-epaper-content').show();
  $('.long-epaper-content').append(
    `<div class="long-epaper-list long-epaper-animation">${longEpaperHtml}</div>`
  );
  setTimeout(() => {
    $('.long-epaper-enter').show();
  }, longEpaperAnimationDuration * 1000 * 0.35);
  initPageData();
};

let allTotal: number = 0;
let allLoad: number = 0;
let loadImages = 0;
const setLoadPercent = () => {
  const percentComplete = allLoad / allTotal;
  $('.loading-bar-mask').css({
    width: `${100 - 100 * percentComplete}%`,
  });
  if (percentComplete >= 1 && loadImages >= longEpapers.length) {
    setTimeout(() => {
      initLongEpaper();
    }, 500);
  }
};
/**
 * 通过xhr的方式提前加载长图，避免直接滚动长图时导致的图片没能加载出来的问题
 * 不适用image.onload，因为需要通过xhr来监听图片加载进度，填充页面的进度条
 */
const initLoadLongEpaper = () => {
  longEpapers.forEach((longEpaper) => {
    $.ajax(longEpaper, {
      xhr() {
        const xhr = new XMLHttpRequest();
        let hasLoad = 0;
        xhr.addEventListener('load', () => {
          loadImages += 1;
          setLoadPercent();
        });
        xhr.addEventListener(
          'progress',
          (evt) => {
            if (evt.lengthComputable) {
              if (!hasLoad) {
                allTotal += evt.total;
              }
              allLoad += evt.loaded - hasLoad;
              hasLoad = evt.loaded;
              setLoadPercent();
            }
          },
          false
        );
        return xhr;
      },
    });
  });
};

$(window).on('load', () => {
  document.body.style.setProperty(
    '--long-epaper-slide-duration',
    `${longEpaperAnimationDuration}s`
  );
  bodyHeight = document.body.clientHeight;
  document.title =
    process.env.PROJECT_TITLE || process.env.WECHAT_SHARE_TITLE || '';
  if (loadingStyle === 'bar') {
    $('.loading-bar-box').show();
    $('.loading-circle-box').hide();
  } else if (loadingStyle === 'circle') {
    $('.loading-bar-box').hide();
    $('.loading-circle-box').show();
    $('.loading-circle-svg').attr('src', loadingSvg);
    if (showLoadingText) {
      $('.loading-circle-text').show();
    } else {
      $('.loading-circle-text').hide();
    }
  }
  YouMeng.pushRecord({ issue_name: issueName }, 'gzcmc.xhc.h5.onload', 'lOAD');
  initContainerSize();
  initBgm();
  if (longEpapers.length) {
    initLoadLongEpaper();
  } else {
    initPageData();
  }
  initEvent();
  window.onresize = throttle(initContainerSize, 250);
  initWxShare();
  YouMeng.initYoumeng();
  YouMeng.initYoumengLog();
  if (process.env.BUILD_ENV === 'staging') {
    $('.container').append(`<img src=${tastTag} class="test-tag" />`);
  }
});
